import { handleVFGCalculation } from './vfgCalculator';
import { handleEstadoParasitologicoSeriadoCalculation } from './estadoParasitologicoSeriadoCalculator';
import { handleEstadoTestDeGrahamCalculation } from './estadoTestDeGrahamCalculator';
import { PROCEDURE_CALCULATOR_MAP, PROCEDURE_CODES, CALCULATOR_TYPES } from './calculatorRegistry';

export const handleProcedureCalculation = async (procedureCode, value, admissionPatientId, form, procedures, user) => {
  const calculatorConfig = PROCEDURE_CALCULATOR_MAP[procedureCode];
  
  if (!calculatorConfig) return null;

  const targetProcedureCodes = calculatorConfig.targetFields;
  const targetProceduresExists = procedures.some(proc => targetProcedureCodes.includes(proc.code));

  if (!targetProceduresExists) {
    console.warn(`No se encontró procedimiento de destino con códigos '${targetProcedureCodes}'. No se realizará el cálculo.`);
    return null;
  }

  switch (calculatorConfig.type) {
    case CALCULATOR_TYPES.VFG:
      return await handleVFGCalculation(value, admissionPatientId, form, procedures);
    case CALCULATOR_TYPES.ESTADO_1_PARASITOLOGICO_SERIADO:
      return await handleEstadoParasitologicoSeriadoCalculation(value, admissionPatientId, form, procedures, user);
    case CALCULATOR_TYPES.ESTADO_1_TEST_DE_GRAHAM:
      return await handleEstadoTestDeGrahamCalculation(value, admissionPatientId, form, procedures, user);
    default:
      return null;
  }
};

export {
  PROCEDURE_CODES,
  CALCULATOR_TYPES
};
